import { render, staticRenderFns } from "./HmActivityCoupons.vue?vue&type=template&id=2efd150e&scoped=true&"
import script from "./HmActivityCoupons.vue?vue&type=script&lang=js&"
export * from "./HmActivityCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd150e",
  null
  
)

component.options.__file = "HmActivityCoupons.vue"
export default component.exports